import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=57951a64&scoped=true&"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=57951a64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57951a64",
  null
  
)

export default component.exports